import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/app/src/app/(auth)/components/ForgotPasswordForm/ForgotPasswordForm.tsx");
